export class ProposalModel {
  isSelected = false;
  constructor(
    public proposalId: string,
    public proposalStatus: { code: string, name: string; },
    public proposalUser: { userId: string, userName: string; },
    public reportOutputDate: string,
    public classCode: string,
    public preferredStartOrderCode: string,
    public preferredStartDelivCatalogId: string,
    public buyer: { buyerId: string, buyerName: string; },
    public pcode: string,
    public itemCode: string,
    public goodsNameAndStandardName: string,
    public masterInputId: string,
    public masterInputStatus: string
  ) { }
} 